import React from 'react';
import { useParams } from 'react-router-dom';
import VehicleForm from './VehicleForm.js';

export default function EditVehicleForUser() {
  const { id, vehicleId } = useParams();
  return <VehicleForm id={Number(vehicleId)} userId={Number(id)} />;
}
